import { useNavigate } from "react-router-dom";

const useRedirect = () => {
  const navigate = useNavigate();

  const redirect = (path, state = {}) => {
    if (path) {
      navigate(path, { state }); // ✅ forward state
    } else {
      navigate("/blank", { state: { path } });
    }
  };

  return redirect;
};

export default useRedirect;
